import {Component, Input} from '@angular/core';
import {Photo} from '../../../models/photo';

@Component({
    selector: 'app-prd-jumbotron',
    templateUrl: './prd-jumbotron.component.html',
    standalone: false
})
export class PrdJumbotronComponent {
    @Input() photo?: Photo|null;
    @Input() title = '';
    @Input() commercialProjectName: string|null = '';
    @Input() subtitle = '';
    @Input() company = '';
}
